import clsx from 'clsx';
import {
  Close,
  FastForward,
  FastRewind,
  FiberManualRecord,
  Pause,
  PlayArrow,
  SkipNext,
  SkipPrevious,
  Stop,
} from '@material-ui/icons';
import Draggable from 'react-draggable';
import { IconButton } from '../../components/IconButton';
import { useCitrusView } from '../../contexts/CitrusViewContext';
import { useSort } from '../../hooks/useSort';

interface Props {
  open: boolean;
  onClose(): void;
}

export const MobilePlaybackButtons = ({ open, onClose }: Props) => {
  const { remote, remoteLoading, sendCommand } = useCitrusView();
  const { sortAsc } = useSort<{ order: number }>('order');
  const buttons = (remote?.buttons ?? [])
    .filter((button) => button.category === 'PLAYBACK')
    .sort(sortAsc);
  const classes = useStyles();

  const renderButtonIcon = (buttonName: string) => {
    switch (buttonName.toUpperCase()) {
      case 'PLAY':
        return <PlayArrow />;
      case 'STOP':
        return <Stop />;
      case 'PAUSE':
        return <Pause />;
      case 'FF':
        return <FastForward />;
      case 'REPLAY':
        return <SkipPrevious />;
      case 'REW':
        return <FastRewind />;
      case 'REC':
        return <FiberManualRecord />;
      case 'SKIP':
        return <SkipNext />;
    }
  };

  if (open === false) return null;

  return (
    <Draggable defaultClassName="z-[9999] shadow-2xl" bounds="parent">
      <div className="absolute bottom-[calc(50%-100px)] left-[70px] p-4 gap-2 rounded grid grid-cols-4 bg-black/70">
        <div className="inline-flex items-center justify-between col-span-full py-2">
          <IconButton
            className="absolute top-0 right-0 pointer-events-auto"
            onClick={onClose}
            onTouchEnd={onClose}
          >
            <Close />
          </IconButton>
        </div>
        {(buttons ?? []).map((button) => (
          <button
            className={clsx(classes.button, {
              '!text-xs':
                button.name.toLowerCase() === 'delete' ||
                button.name.toLowerCase() === 'enter',
            })}
            onClick={() => sendCommand(button.id)}
            onTouchEnd={() => sendCommand(button.id)}
          >
            {renderButtonIcon(button.name)}
          </button>
        ))}
      </div>
    </Draggable>
  );
};

const useStyles = () => ({
  button:
    'pointer-events-auto rounded-full border border-border-white h-14 w-14 text-2xl flex items-center justify-center focus:bg-white/20 active:bg-white/20 disabled:opacity-20',
  textButton:
    'bg-transparent text-xs active:text-white/20 focus:bg-white/20 active:bg-white/20 rounded-full px-2 py-1 disabled:opacity-20',
});
